var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headerNav',{staticClass:"nav_b",attrs:{"leftNav":"返回","title":_vm.routerRow.title},on:{"leftClick":_vm.back}}),_c('div',{staticClass:"echartMain"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }